import i18n from '@/plugins/i18n';
const instanceGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      language: 'JAVA',
      isCommon: true,
      isForecast: true,
      title: i18n.global.t('apm.service-instance-load'),
      header: {
        title: i18n.global.t('loadTitle'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: false,
        displayCustomButton: false,
        subIconTitle: 'starFilled',
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#008FFB'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_total_call',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'ServiceInstance',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_instance_cpm',
          queryMetricType: 'readMetricsTotalValue',
          name: 'total',
        },
        {
          entityType: 'ServiceInstance',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_instance_cpm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartLine',
      unit: i18n.global.t('cpmWithFullForm'),
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfCalls'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'JAVA',
      isCommon: true,
      isForecast: true,
      title: i18n.global.t('error'),

      header: {
        title: i18n.global.t('error'),
        titleIcon: 'error',
        content: [],
        isError: true,
        displayCustomButton: true,
        subIconTitle: 'starFilled',
        customButtonProp: {
          title: i18n.global.t('bm.error-traces'),
          key: 'error',
        },
      },
      chartColor: ['#FF8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_error_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'ServiceInstance',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_instance_error_percent',
          queryMetricType: 'readMetricsValue',
          name: 'percentage',
        },
        {
          entityType: 'ServiceInstance',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_instance_epm',
          queryMetricType: 'readMetricsTotalValue',
          name: 'total',
        },
        {
          entityType: 'ServiceInstance',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_instance_epm',
          queryMetricType: 'readMetricsValue',
          name: 'pm',
        },
      ],
      chartType: 'ApexChartLine',
      unit: 'No',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfErrors'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
    },
    {
      width: '48%',
      language: 'JAVA',
      isCommon: true,
      isForecast: true,

      title: i18n.global.t('apm.instance-service-instance-successful-rate'),
      header: {
        title: i18n.global.t('responseTimeWithoutUnit'),
        titleIcon: '',
        content: [],
        displayOnlyUnit: true,
        displayCustomButton: true,
        HideCenterMiscContent: false,
        subIconTitle: 'starFilled',
        customButtonProp: {
          title: i18n.global.t('bm.slow-traces'),
          key: 'slow',
        },
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'service_instance_resp_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [
        {
          entityType: 'ServiceInstance',
          independentSelector: false,
          metricType: 'REGULAR_VALUE',
          metricName: 'service_instance_resp_time',
          queryMetricType: 'readMetricsValue',
          name: 'total',
        },
      ],
      chartType: 'ApexChartLine',
      unit: 'ms',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('responseTimeWithUnit'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'ms',
      },
      compareTrend: true,
    },
    {
      width: '48%',
      language: 'JAVA',
      isCommon: false,
      title: i18n.global.t('apm.instance-jvm-cpu-java-service'),

      header: {
        title: i18n.global.t('apm.jvm-cpu'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#c322ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'instance_jvm_cpu',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
      compareTrend: true,
    },
    {
      aggregation: '/',
      aggregationNum: '1048576',
      width: '48%',
      language: 'JAVA',

      isCommon: false,
      title: i18n.global.t('apm.instance-jvm-memory-java-service'),
      header: {
        title: i18n.global.t('apm.jvm-memory-mb'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#EDF67D', '#F896D8', '#CA7DF9', '#724CF9', '#A8DADC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'instance_jvm_memory_heap, instance_jvm_memory_heap_max,instance_jvm_memory_noheap, instance_jvm_memory_noheap_max',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: 'MB',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'JAVA',
      isCommon: false,
      title: i18n.global.t('apm.instance-jvm-gc-time'),

      header: {
        title: i18n.global.t('apm.gc-time-ms'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#FFBE0B', '#FB5607', '#FF006E', '#8338EC'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'instance_jvm_young_gc_time, instance_jvm_old_gc_time',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('aws.timeInMs'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'JAVA',
      isCommon: false,
      title: i18n.global.t('apm.instance-jvm-gc-count'),

      header: {
        title: i18n.global.t('apm.gc-count'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#1BE7FF', '#6EEB83', '#E4FF1A'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'instance_jvm_young_gc_count, instance_jvm_old_gc_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('apm.gc-count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },

    {
      width: '48%',
      language: 'JAVA',
      isCommon: false,

      title: i18n.global.t('apm.instance-jvm-thread-count-java-service'),
      header: {
        title: i18n.global.t('apm.thread-count'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#4384B0', '#FFDA85', '#D67B5C'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'instance_jvm_thread_live_count, instance_jvm_thread_daemon_count, instance_jvm_thread_peak_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfThreads'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'DOTNET',
      isCommon: false,

      title: i18n.global.t('apm.instance-clr-cpu-net-service'),
      header: {
        title: i18n.global.t('apm.clr-cpu'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#c322ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'instance_clr_cpu',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('apm.cpu-percentage'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'DOTNET',
      isCommon: false,

      title: i18n.global.t('apm.instance-clr-gc-net-service'),
      header: {
        title: i18n.global.t('apm.clr-gc-count'),
        HideCenterMiscContent: true,
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#4384B0', '#FFDA85', '#D67B5C'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'instance_clr_gen0_collect_count, instance_clr_gen1_collect_count, instance_clr_gen2_collect_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('apm.gc-count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'DOTNET',
      isCommon: false,

      title: i18n.global.t('apm.instance-clr-heap-memory-net-service'),
      header: {
        title: i18n.global.t('apm.clr-heap-memory-bytes'),
        HideCenterMiscContent: true,
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#f4d21b'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'instance_clr_heap_memory',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '%',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('apm.bytes'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
    {
      width: '48%',
      language: 'DOTNET',
      isCommon: false,

      title: i18n.global.t('apm.instance-clr-thread-net-service'),
      header: {
        title: i18n.global.t('apm.clr-thread-count'),
        titleIcon: '',
        content: [],
        displayCustomButton: false,
        HideCenterMiscContent: true,
        customButtonProp: {
          title: '',
        },
      },
      chartColor: ['#f20e76', '#4384B0', '#FFDA85', '#D67B5C'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'instance_clr_available_completion_port_threads,instance_clr_available_worker_threads,instance_clr_max_completion_port_threads,instance_clr_max_worker_threads',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      isMultiLineSeriesTooltip: true,
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
});

export default instanceGraphs;
